
import HouseContact from './shop-card/house-contact.vue';
import HouseSignup from './shop-card/house-signup.vue';
import CommonCardContact from './shop-card/commom-card-contact.vue';
import ArtLeftImg from './outlink-module/art-left-img.vue';
import ArtPoster from './outlink-module/art-poster.vue'
import ArtInsertConfig from './article_config.js'
import QrCode from './shop-card/qrcode.vue';
import Vote from './shop-card/vote/index.vue'; // 投票

function ArticleInsertOutlink(opt) {
    this.data = opt.data;
    this.$el = opt.el;
    this.uuid = opt.uuid;
    this.dataType = opt.dataType;
    this.templateSpm = opt?.templateSpm;
}
ArticleInsertOutlink.prototype = {
    constructor: ArticleInsertOutlink,
    init: function(){
        var articleDom = this.render(this.data);
        this.$el.appendChild(articleDom)
    },
    render: function(data) {
        var insertType = this.dataType;
        var ArticleItem = this.getTemplateName(insertType,data);
        var ArticleCon = Vue.extend(ArticleItem);
        var artItem = new ArticleCon({
            el: document.createElement('div'),
            data: {
                uuid: this.uuid,
                insertType: insertType,
                articleData: data,
                templateSpm: this.templateSpm
            }
        });
        return artItem.$el
    },
    getTemplateName: function (type,data) {
        if(+type == ArtInsertConfig.commonCon) {
            return CommonCardContact
        }
        if(+type == ArtInsertConfig.contact) {
            return HouseContact
        }
        if(ArtInsertConfig.signup.indexOf(+type)>-1) {
            return HouseSignup
        }
        if(ArtInsertConfig.artLeftImg.indexOf(+type) > -1) {
            return ArtLeftImg
        }
        if(ArtInsertConfig.artPoster.indexOf(+type) > -1){
            return ArtPoster
        }
        if (ArtInsertConfig.qrCode.indexOf(+type) > -1) {
            return QrCode
        }
        if (ArtInsertConfig.vote.indexOf(+type) > -1) {
            window.eventBus.$emit('renderVoteCardFinish',data)
            return Vote
        }
    }
}
export default ArticleInsertOutlink;
